import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import classes from './BuilderTabs.module.scss'

const TABS = ['curriculum', 'settings']

const BuilderTabs = ({ tab, onChange }) => {
  const { t } = useTranslation()

  return (
    <nav className={classNames('d-flex align-items-end', classes.bar)}>
      {TABS.map(key => (
        <button key={key} className={classNames(classes.tab, { [classes.tabActive]: key === tab })} onClick={() => onChange(key)}>
          {t(`certificationBuilder.tabs.${key}`)}
        </button>
      ))}
    </nav>
  )
}

BuilderTabs.propTypes = {
  tab: PropTypes.oneOf(TABS).isRequired,
  onChange: PropTypes.func.isRequired,
}

export default BuilderTabs
